import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import IPDPatientReport from "./Reports/IPDPatientReport";
import BillStatements from "./Billing/BillStatements";
import DatewiseBilling from "./Billing/DatewiseBilling";
import { FaUserFriends, FaFileInvoice, FaCalendarAlt } from "react-icons/fa";
import classes from "./IPDReports.module.css";

const IPDReports = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("patient");

    return (
        <div className={classes.reportsContainer}>
            {/* 🔹 Enhanced Tabs Section */}
            <div className={classes.tabsContainer}>
                <button
                    className={`${classes.tabBtn} ${activeTab === "patient" ? classes.activeTab : ""}`}
                    onClick={() => setActiveTab("patient")}
                >
                    <FaUserFriends className={classes.tabIcon} />
                    <span>{t("IPD Report")}</span>
                </button>

                <button
                    className={`${classes.tabBtn} ${activeTab === "billStatement" ? classes.activeTab : ""}`}
                    onClick={() => setActiveTab("billStatement")}
                >
                    <FaFileInvoice className={classes.tabIcon} />
                    <span>{t("Billing Statement")}</span>
                </button>

                <button
                    className={`${classes.tabBtn} ${activeTab === "datewiseBilling" ? classes.activeTab : ""}`}
                    onClick={() => setActiveTab("datewiseBilling")}
                >
                    <FaCalendarAlt className={classes.tabIcon} />
                    <span>{t("Datewise Billing")}</span>
                </button>
            </div>

            <div className={classes.contentPanel}>
                {activeTab === "patient" && <IPDPatientReport />}
                {activeTab === "billStatement" && <BillStatements />}
                {activeTab === "datewiseBilling" && <DatewiseBilling />}
            </div>
        </div>
    );
};

export default IPDReports;
